import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { fontDisplay, fontText, StylesIndexInjections } from 'common-react';
import { AccordionStyleProps } from './Accordion';
import { focusStyle } from '../styles/mixins';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    boxShadow: 'none',
    backgroundColor: ({transparent}: AccordionStyleProps) => transparent ? 'transparent' : theme.color.greys[0],
    padding: 0,

    '& .MuiCollapse-root': {
      transition: '300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },

    '& > .MuiAccordionSummary-root': {
      width: '100%',
      padding: ({ type }: AccordionStyleProps) => type === 'primary' ? '16px 16px 16px 8px' : 0,
      minHeight: 8,
      borderTop: ({ type }: AccordionStyleProps) => type === 'primary' ? `1px solid ${theme.color.greys[15]}` : 'none',
      '&.Mui-focused': {
        background: 'transparent'
      },
      '&.Mui-focusVisible': {
        ...focusStyle(theme, -2),
      },
    },

    '& .MuiAccordionSummary-expandIcon': {
      padding: 0,
      marginRight: 0,
      marginLeft: 4,
    },



    '&.Mui-disabled': {
      opacity: 1,
      backgroundColor: 'transparent',
      pointerEvents: 'all',

      '& > .MuiAccordionSummary-root.Mui-disabled': {
        pointerEvents: 'all',
        opacity: 1,
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-expanded': {
      marginTop: 0,

      '& > .MuiAccordionSummary-root > .MuiAccordionSummary-content > $title::after': {
        transform: 'rotate(180deg)',
      }
    },
    '&::before': {
      display: 'none',
    },
    '& > div.Mui-expanded': {
      minHeight: 0,
      borderBottomColor: 'transparent',
    },
    '& div.MuiAccordionSummary-content, & div.MuiAccordionSummary-content.Mui-expanded': {
      margin: ({ type }: AccordionStyleProps) => type === 'primary' ? '0' : '16px 0',
    },
  },
  expandIcon: {
    width: 16,
    height: 16,
    padding: 0,
    margin: 0,
    top: -4,
    color: theme.color.greys[80],
  },
  title: {
    width: ({ type }: AccordionStyleProps) => type === 'primary' ? '100%' : 'auto',
    font: fontDisplay('normal', theme.fontSize.l, 28),
    color: theme.color.greys[80],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  details: {
    width: '100%',
    font: fontText('normal', theme.fontSize.base, 24),
    padding: '16px 16px 24px 16px',
  },
}), { name: 'Accordion', index: StylesIndexInjections.UI_MOLECULES });
